<div oui-dialog-title>
  Désactiver l'habilitation "{{ habilitationName }}"

  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content class="dialog-content">
  <span>Cette action est irréversible et entraînera une perte d'habilitation.</span>

  <oui-textfield
    label="Mot de confirmation"
    placeholder="Tapez le mot demandé"
    hint="Saisissez DESACTIVER pour confirmer votre volonté de désactiver cette habilitation pour le consultant."
    [control]="confirmationControl"
    [errors]="confirmationErrors">
  </oui-textfield>

  @if (isLoading()) {
    <div class="loading-container">
      <oui-loading></oui-loading>
    </div>
  }
</oui-dialog-content>

<oui-dialog-actions class="dialog-actions">
  <oui-button type="text" [disabled]="isLoading()" oui-dialog-close>Annuler</oui-button>
  <oui-button
    [type]="confirmationControl.valid ? 'contained' : 'outlined'"
    [disabled]="isLoading()"
    (click)="deactivateHabilitation()"
    >Confirmer</oui-button
  >
</oui-dialog-actions>
